import { MrbBaseInfiniteScrollListViewStore } from "mrb/core";
import { AnalyticsTimeRangeViewStore } from "administration/analytics/stores";
import { AnalyticsFilter } from "administration/analytics/filters";
import { timeRangeType } from "administration/analytics/constants";
import { MrbInfiniteScrollGridViewStore } from "mrb/components/infinite-scroll-grid";
import { action, observable, computed, makeObservable } from "mobx";

class TrendingNakiNigunAlbumListViewStore extends MrbBaseInfiniteScrollListViewStore {
    @observable selectedFilterOption = 1;

    filterOptions = [
        { value: 1, label: "Streams" },
        { value: 2, label: "Unique Listeners" },
    ];

    @computed get uniqueListeners() {
        return this.selectedFilterOption === 2;
    }
    constructor(rootStore, { routeStore }) {
        super(rootStore, {
            queryConfig: {
                filter: new AnalyticsFilter(),
                paramKeyMap: {
                    _range: "range",
                },
                ignoreQueryParams: ["page", "timeZone", "rpp"],
                queryParamMap: {
                    from: {
                        toQuery: (value) => {
                            if (this.queryUtility.filter.range === timeRangeType.custom) {
                                return value;
                            }
                            return undefined;
                        },
                    },
                    to: {
                        toQuery: (value) => {
                            if (this.queryUtility.filter.range === timeRangeType.custom) {
                                return value;
                            }
                            return undefined;
                        },
                    },
                },
            },
        });
        makeObservable(this);

        this.routeStore = routeStore;

        this.analyticsTimeRangeViewStore = new AnalyticsTimeRangeViewStore(this.rootStore, {
            queryUtility: this.queryUtility,
        });

        this.setGridStore(
            new MrbInfiniteScrollGridViewStore(this.rootStore, this.queryUtility, {
                generateKey: (item) => item.id,
                mapper: (item) => {
                    return {
                        id: item.nakiNigunAlbumId,
                        title: item.nakiNigunAlbum ? item.nakiNigunAlbum.title : "Unknown album",
                        isPremium: item.nakiNigunAlbum && item.nakiNigunAlbum.isPremium,
                        coverImageUrl: this.createCoverImageUrl(item.nakiNigunAlbum),
                        score: item.currentCycleScore,
                        currentCyclePosition: item.currentCyclePosition,
                        previousCyclePosition: item.previousCyclePosition,
                        routeParams: item.nakiNigunAlbum
                            ? {
                                  route: "master.administration.analytics.naki-nigun-album-activity",
                                  params: { id: item.nakiNigunAlbum.id },
                                  queryParams: this.rootStore.routerStore.routerState.queryParams,
                              }
                            : null,
                    };
                },
            })
        );

        this.createCoverImageUrl = this.createCoverImageUrl.bind(this);
    }

    find(params) {
        const filter = {
            from: params.from,
            to: params.to,
            previousCycleFrom: params.previousCycleFrom,
            previousCycleTo: params.previousCycleTo,
            timeZone: params.timeZone,
            pageNumber: params.pageNumber,
            pageSize: 30,
            uniqueListeners: this.uniqueListeners,
        };
        return this.routeStore.getTrendingNakiNigunAlbums(filter);
    }

    createCoverImageUrl(item) {
        if (item && item.coverImageId) {
            return this.routeStore.createNakiNigunAlbumCoverImageUrl(item.coverImageId, 150, 150);
        }
        return null;
    }

    @action.bound
    setFilterOption(value) {
        this.selectedFilterOption = value;
        this.analyticsTimeRangeViewStore.queryUtility.fetch();
    }
}

export default TrendingNakiNigunAlbumListViewStore;
